import * as loginErrorMessageUtils from 'login-utils/loginErrorMessageUtils';
export interface QueryProps {
  message: string;
  username?: string;
  from?: 'loginEmail'; // indicate which is the previous page.
  email?: string;
}

export interface LoginState {
  successMessage?: string;
  errorMsg?: string;
}

interface LoginDefaultValues {
  successMsg?: string | false | null;
  errorMsg?: string;
  queryProps: QueryProps;
}

export function getLoginDefaultValues(queryProps: QueryProps, successMessage?: string): LoginDefaultValues {
  const errorData = loginErrorMessageUtils.generate(queryProps.message);
  const errorMsg = errorData && errorData.type === 'error' ? errorData.message : undefined;
  const successMsg = successMessage || (errorData && errorData.type === 'success' && errorData.message);
  return {
    successMsg,
    errorMsg,
    queryProps,
  };
}

export const SSO_REDIRECT_URL = '/auth/saml';
